<template>
  <span class="serp__filter--label-container q-fs-6 q-d-inline">
    <span class="serp__filter--label"> {{ filter.label }} </span>
    <small class="serp__filter--badge q-text-muted q-d-none"> ({{ filter.count }})</small>
  </span>
</template>
<script setup lang="ts">
import {defineProps} from "vue";

defineProps(['filter'])
</script>
<style scoped>
.serp__filter--label{
  vertical-align: sub;
}
/*.serp__filter--label-container{*/
/*  text-wrap: nowrap;*/
/*}*/
</style>
